export class FetchError extends Error {
  constructor (
    public status: number,
    message: string,
    public response?: Response
  ) {
    super(`${message} (status: ${status})`)
    this.name = 'FetchError'
  }
}

export const checkFetchError = (status: number, response?: Response): void => {
  if (status >= 400 && status < 500) {
    throw new FetchError(status, 'client error', response)
  }
  if (status >= 500 && status < 600) {
    throw new FetchError(status, 'server error', response)
  }
}
